import { components } from "@certn/api/generated-schemas/applicant-portal";

type OneIdCheckStatusResponse =
  components["schemas"]["OneIDCheckStatusResponse"];
type CheckStatus = components["schemas"]["CheckStatus"];

/**
 * Mirrors backend is_one_id_complete() for standalone ONE_ID_1 (FR-759).
 * Complete only when the check is COMPLETE or the session-complete flag is set;
 * IN_PROGRESS without the flag is still an unfinished session.
 */
export function isOneId1SectionComplete(
  response: OneIdCheckStatusResponse | undefined
): boolean {
  if (!response) {
    return false;
  }

  const checkStatus = response.check_status as CheckStatus | undefined;
  if (checkStatus === "COMPLETE") {
    return true;
  }
  if (response.one_id_session_complete) {
    return true;
  }
  return false;
}
